import * as React from "react";

export const FormErrorMessage = (error: string) => {
  return (
    <div className="p-4 text-center rounded bg-red-700 mb-4 flex-shrink-0">
      <span className="text-white font-bold block">{error}</span>
    </div>
  );
};
